import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={78.634}
      height={124.704}
      viewBox="0 0 78.634 124.704"
      {...props}
    >
      <g data-name="Group 695">
        <g data-name="ceiling-lamp (1)">
          <g data-name="Group 132">
            <path
              data-name="Path 1072"
              d="M43.386 24.076h-7.679v-7.731a1.972 1.972 0 011.971-1.972h3.737a1.972 1.972 0 011.972 1.972v7.731z"
              fill="#165a9f"
            />
            <path
              data-name="Path 1073"
              d="M39.547 44.949a5.808 5.808 0 01-5.808-5.808V34.57h11.616v4.574a5.808 5.808 0 01-5.808 5.808z"
              fill="#ffd200"
            />
            <path
              data-name="Path 1074"
              d="M43.386 19.057v.489l-5.96-.823A15.559 15.559 0 0023.99 34.136v4.551a1.07 1.07 0 001.07 1.071h28.972a1.071 1.071 0 001.071-1.071v-4.551a15.563 15.563 0 00-11.717-15.079z"
              fill="#003586"
            />
            <path
              data-name="Path 1075"
              d="M39.546 18.579a15.691 15.691 0 00-2.124.145 15.559 15.559 0 0113.432 15.412v4.551a1.07 1.07 0 01-1.07 1.071h4.248a1.07 1.07 0 001.07-1.071v-4.551a15.557 15.557 0 00-15.556-15.557z"
              fill="#165a9f"
            />
          </g>
          <g data-name="Group 133">
            <path
              data-name="Path 1076"
              d="M48.879 39.758a.8.8 0 00-.8-.8H25.06a.268.268 0 01-.268-.268v-4.557a14.684 14.684 0 012.482-8.194.803.803 0 10-1.335-.893 16.284 16.284 0 00-2.753 9.087v4.551a1.876 1.876 0 001.873 1.873h8.03a6.61 6.61 0 0012.912 0h2.073a.8.8 0 00.805-.799zm-9.332 4.388a4.992 4.992 0 01-4.8-3.585h9.6a4.991 4.991 0 01-4.801 3.585z"
            />
            <path
              data-name="Path 1077"
              d="M50.549 22.029a16.32 16.32 0 00-6.36-3.581v-2.1a2.778 2.778 0 00-2.774-2.774H40.35V.8a.803.803 0 10-1.606 0v12.771h-1.065a2.778 2.778 0 00-2.774 2.774v2.1a16.318 16.318 0 00-6.4 3.622.803.803 0 001.085 1.184 14.754 14.754 0 0119.882-.038 14.79 14.79 0 014.832 10.919v4.551a.268.268 0 01-.268.268h-2.21a.803.803 0 000 1.606h2.21a1.876 1.876 0 001.873-1.873v-4.548a16.4 16.4 0 00-5.36-12.107zm-7.966-3.971a16.491 16.491 0 00-6.074 0v-1.712a1.17 1.17 0 011.169-1.169h3.736a1.17 1.17 0 011.169 1.169z"
            />
            <path
              data-name="Path 1078"
              d="M39.543 48.383a.8.8 0 00-.8.8v4.822a.803.803 0 001.606 0v-4.822a.8.8 0 00-.806-.8z"
            />
            <path
              data-name="Path 1079"
              d="M48.772 45.416a.803.803 0 10-1.136 1.135l3.406 3.41a.803.803 0 101.136-1.135z"
            />
            <path
              data-name="Path 1080"
              d="M30.321 45.416l-3.406 3.41a.803.803 0 101.136 1.135l3.406-3.41a.803.803 0 10-1.136-1.135z"
            />
          </g>
        </g>
        <g data-name="conference (2)">
          <g data-name="Group 134">
            <path
              data-name="Path 1081"
              d="M39.315 47.911a10.551 10.551 0 00-10.52 10.519v2.756c5.773-8.36 10.4-.03 21.036 0V58.43a10.548 10.548 0 00-10.516-10.519z"
              fill="#ffcd69"
              fillRule="evenodd"
            />
          </g>
          <g data-name="Group 135">
            <path
              data-name="Path 1082"
              d="M49.833 61.186c-10.635-.03-15.263-8.36-21.036 0v3.74c0 2.386 1.641 4.689 3.766 6.4a12.013 12.013 0 006.752 2.9 12.024 12.024 0 006.757-2.9c2.12-1.715 3.761-4.019 3.761-6.4v-3.74z"
              fill="#ffdcd5"
              fillRule="evenodd"
            />
          </g>
          <g data-name="Group 136">
            <path
              data-name="Path 1083"
              d="M32.563 71.331l-3.766 3.849 6.887 6.352 3.631-7.306a12.013 12.013 0 01-6.752-2.895z"
              fill="#ebddd9"
              fillRule="evenodd"
            />
          </g>
          <g data-name="Group 137">
            <path
              data-name="Path 1084"
              d="M35.685 81.532l-6.887-6.352c-6.064 2.808-7.013 6.683-7.013 16.157h35.062c0-9.474-.949-13.349-7.013-16.157l-6.887 6.352-3.631-7.306z"
              fill="#fb8145"
              fillRule="evenodd"
            />
          </g>
          <g data-name="Group 138">
            <path
              data-name="Path 1085"
              d="M46.072 71.331a12.025 12.025 0 01-6.757 2.9l3.631 7.306 6.887-6.352z"
              fill="#ebddd9"
              fillRule="evenodd"
            />
          </g>
          <g data-name="Group 139">
            <path
              data-name="Path 1086"
              d="M21.784 91.337H4.069a2.537 2.537 0 00-2.337 1.555v4.615a2.537 2.537 0 002.333 1.55h70.5a2.539 2.539 0 002.534-2.534v-2.647a2.542 2.542 0 00-2.534-2.534H21.784z"
              fill="#003586"
              fillRule="evenodd"
            />
          </g>
          <g data-name="Group 140">
            <path
              data-name="Path 1087"
              d="M71.491 99.052H7.143l5.873 22.989c.187.74.4 1.128 1.08 1.128h50.443c.679 0 .888-.387 1.08-1.128zm-48.876 14.747v-5.377a1.961 1.961 0 011.959-1.955H54.06a1.964 1.964 0 011.959 1.955v5.377a1.965 1.965 0 01-1.959 1.959H24.574a1.962 1.962 0 01-1.959-1.959z"
              fill="#165a9f"
              fillRule="evenodd"
            />
          </g>
          <g data-name="Group 141">
            <path
              data-name="Path 1088"
              d="M54.064 106.467h-29.49a1.961 1.961 0 00-1.959 1.955v5.377a1.962 1.962 0 001.959 1.959h29.49a1.965 1.965 0 001.959-1.959v-5.377a1.964 1.964 0 00-1.959-1.955z"
              fill="#ebddd9"
              fillRule="evenodd"
            />
          </g>
          <g data-name="Group 142">
            <path
              data-name="Path 1089"
              d="M11.78 71.47l-1.432 1.707a3.437 3.437 0 105.268 4.415l1.432-1.707a3.437 3.437 0 10-5.268-4.415z"
              fill="#ebddd9"
              fillRule="evenodd"
            />
          </g>
          <g data-name="Group 143">
            <path
              data-name="Path 1090"
              d="M62.01 71.043a3.449 3.449 0 00-.422 4.842l1.428 1.707a3.437 3.437 0 005.268-4.415l-1.432-1.707a3.444 3.444 0 00-4.842-.427z"
              fill="#ebddd9"
              fillRule="evenodd"
            />
          </g>
          <g data-name="Group 144">
            <path
              data-name="Path 1091"
              d="M21.079 108.422v5.377a3.5 3.5 0 003.495 3.5H54.06a3.5 3.5 0 003.495-3.5v-5.377a3.5 3.5 0 00-3.495-3.491H24.574a3.5 3.5 0 00-3.495 3.491zm33.4 0v5.377a.429.429 0 01-.423.423H24.574a.424.424 0 01-.423-.423v-5.377a.427.427 0 01.423-.419H54.06a.427.427 0 01.423.419z"
            />
            <path
              data-name="Path 1092"
              d="M74.565 89.801h-.771v-6.543a.713.713 0 00-.024-.249 1.526 1.526 0 00-.334-.722l-3.572-4.265a4.982 4.982 0 00-.4-5.833l-1.43-1.7a4.98 4.98 0 00-7.006-.62 4.977 4.977 0 00-.612 7l1.422 1.706a4.937 4.937 0 003.375 1.756q.225.02.447.02a4.937 4.937 0 001.849-.358l3.212 3.836v5.969h-12.35c-.123-8.626-1.421-12.911-7.628-15.887l-2.465-2.522a9.483 9.483 0 003.09-6.466v-6.5a12.054 12.054 0 10-24.108 0v6.5a9.484 9.484 0 003.092 6.467l-2.466 2.52c-6.208 2.977-7.505 7.262-7.628 15.888H7.908v-5.966l3.212-3.836a4.941 4.941 0 001.85.358q.226 0 .453-.02a4.925 4.925 0 003.368-1.759l1.432-1.7a4.972 4.972 0 00-7.62-6.39l-1.435 1.71a4.991 4.991 0 00-.4 5.828l-3.573 4.264a1.528 1.528 0 00-.353.882v6.633h-.773A4.074 4.074 0 000 93.875v2.647a4.074 4.074 0 004.069 4.07H5.95l5.577 21.83a2.611 2.611 0 002.573 2.282h50.439a2.621 2.621 0 002.568-2.283l5.578-21.833h1.881a4.074 4.074 0 004.069-4.07v-2.643a4.074 4.074 0 00-4.07-4.074zm-7.7-12.96a1.909 1.909 0 01-2.677-.235l-1.43-1.709a1.9 1.9 0 011.624-3.109 1.878 1.878 0 011.287.67l1.431 1.706a1.9 1.9 0 01-.23 2.677zm-55.341-2.677l1.433-1.708a1.884 1.884 0 011.29-.669q.087-.008.172-.008a1.9 1.9 0 011.452 3.118l-1.435 1.71a1.908 1.908 0 01-2.674.235 1.91 1.91 0 01-.238-2.679zm27.791-24.717A8.993 8.993 0 0148.3 58.43v1.153a27.867 27.867 0 01-7.88-2.109 17.363 17.363 0 00-5.991-1.547 6.681 6.681 0 00-4.015 1.314 9 9 0 018.9-7.793zm-8.982 15.479v-3.251c2.736-3.736 4.744-2.964 8.983-1.335a30.343 30.343 0 008.984 2.323v2.264c0 3.773-5.841 7.764-8.982 7.764s-8.985-3.992-8.985-7.765zm17.3 10.2l-4.223 3.889-1.792-3.606a15.166 15.166 0 004.282-2.053zm-10.617.286l-1.796 3.602L31 75.123l1.727-1.765a15.158 15.158 0 004.285 2.05zm-8.481 1.616l6.111 5.637a1.536 1.536 0 002.417-.446l2.252-4.544 2.256 4.538a1.536 1.536 0 002.417.446l6.112-5.635c3.962 2.106 5.083 4.888 5.2 12.777H23.331c.118-7.889 1.239-10.671 5.2-12.777zm47.028 19.49a1 1 0 01-1 1H46.206a1.536 1.536 0 000 3.072h23.308l-5.376 21.043H14.5l-5.379-21.045H32.41a1.536 1.536 0 000-3.072H4.069a1.011 1.011 0 01-1-1v-2.641a1.011 1.011 0 011-1h70.5a1.011 1.011 0 011 1z"
            />
            <path
              data-name="Path 1093"
              d="M39.31 100.588a1.536 1.536 0 10-1.54-1.536 1.534 1.534 0 001.548 1.536z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
